import React from "react";
import { useTranslation } from "@/hooks/useTranslation";

const STYLES = {
    PENDING: { className: "bg-amber-100 text-amber-800", icon: "fa-hourglass-half", label: "invoices.proof.statusPending" },
    REJECTED: { className: "bg-red-100 text-red-800", icon: "fa-times-circle", label: "invoices.proof.statusRejected" },
    ACCEPTED: { className: "bg-green-100 text-green-800", icon: "fa-check-circle", label: "invoices.proof.statusAccepted" },
};

/** Where a bank-transfer proof of payment stands; renders nothing without a proof. */
export const PaymentProofBadge = ({ proof, className = "" }) => {
    const { t } = useTranslation();
    const style = proof && STYLES[proof.status];
    if (!style) return null;

    return (
        <span className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full ${style.className} ${className}`}>
            <i className={`fas ${style.icon}`}></i>
            {t(style.label)}
        </span>
    );
};
